import { render, staticRenderFns } from "./lecturelist.vue?vue&type=template&id=81f151f2&scoped=true"
import script from "./lecturelist.vue?vue&type=script&lang=js"
export * from "./lecturelist.vue?vue&type=script&lang=js"
import style0 from "./lecturelist.vue?vue&type=style&index=0&id=81f151f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f151f2",
  null
  
)

export default component.exports